export default {
  login: {},
  accountInfo: {}
}



// WEBPACK FOOTER //
// ./src/components/account/store/state.js